import React from 'react';
import { Button, ButtonGroup, Typography } from '@mui/material';
import { FormFieldData } from 'components/UserForm';

interface ButtonGroupFieldProps {
  readonly fieldItem: FormFieldData;
  readonly enableSmartMeter?: any; 
}

const ButtonGroupField: React.FC<ButtonGroupFieldProps> = ({ fieldItem, enableSmartMeter }) => {

  console.log("enableSmartMeter",enableSmartMeter)
  
  return (
    <div style={{ marginTop: -8}}>
      <Typography variant="subtitle1" fontSize={13} gutterBottom>
        {fieldItem.label} {"*"}
      </Typography>
      <ButtonGroup fullWidth style={{ gap: 20}}>
        {fieldItem.selectOptions?.map((option: any) => (
          <Button
            key={option.value}
            variant={fieldItem.value === option.value ? 'contained' : 'outlined'}
            color={fieldItem.value === option.value ? 'primary' : 'inherit'}
            onClick={() => fieldItem.onChange?.(option.value)}
            disabled={(option.value?.toUpperCase() === "SMART METER" && enableSmartMeter === true)
              || option.disabled
              || fieldItem.isDisabled}
            style={{border: "1px solid rgb(166, 166, 166)", borderRadius: 6, outline: "none", fontSize: 13}}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default ButtonGroupField; 